import { VNode } from 'vue';
import { DirectiveBinding } from 'vue/types/options';
import { AnalyticsEvent } from '../models';
import { Dictionary } from 'lodash';

export class ExternalCampaignEvent implements AnalyticsEvent {
    name = 'ExternalCampaignEvent';
    constructor(public readonly query: Dictionary<string | (string | null)[]>) { }
}